import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "./controllers"
// import 'popper.js'
import * as bootstrap from "bootstrap"

import Rails from "@rails/ujs"
Rails.start()

// import "./hyphenate"

// Import custom scripts
// import "./blocks"
// import "./projects"
// import "./reports"
// import "./sections"

// Keep scroll position across page reloads
let scrollYSaver = setInterval(() => {
    sessionStorage.setItem("scrollY", window.scrollY)
}, 500)
  
window.addEventListener("DOMContentLoaded", () => {
    const scrollY = sessionStorage.getItem("scrollY")
    if (scrollY !== null) {
      window.scrollTo(0, parseInt(scrollY, 10))
      sessionStorage.removeItem("scrollY")
    }
})